<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb :list="breadcrumbList" />
    <el-card class="main">
      <!-- 标题区域 -->
      <el-row type="flex">
        <img src="@/assets/img/tag.png" alt="" />
        <span class="title_a">重点关注人员基本信息</span>
      </el-row>
      <!-- 表单区域 -->
      <el-form
        ref="form"
        :model="form"
        label-width="auto"
        :rules="rules"
        class="form"
      >
        <el-row type="flex" justify="start" class="pesky">
          <!-- 左侧表单区域 -->
          <el-col
            class="pesky_left"
            :xs="12"
            :sm="12"
            :md="12"
            :lg="16"
            :xl="16"
          >
            <!-- 第一行：人员姓名 + 联系电话 -->
            <el-row>
              <el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
                <el-form-item label="人员姓名：" prop="name">
                  <el-input v-model="form.name" size="large" />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="23"
                :md="23"
                :lg="{ span: 10, offset: 1 }"
                :xl="{ span: 10, offset: 2 }"
              >
                <el-form-item label="联系电话：" prop="mobile">
                  <el-input v-model="form.mobile" size="large" />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第二行：性别 + 民族 -->
            <el-row>
              <el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
                <el-form-item label="性别：" prop="sex">
                  <el-select
                    v-model="form.sex"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in xbList"
                      :key="item.code"
                      :label="item.title"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="23"
                :md="23"
                :lg="{ span: 10, offset: 1 }"
                :xl="{ span: 10, offset: 2 }"
              >
                <el-form-item label="民族：" prop="nation">
                  <el-select
                    v-model="form.nation"
                    filterable
                    placeholder="请选择"
                    style="width: 100%"
                    :disabled="guojiDisabled"
                  >
                    <el-option
                      v-for="item in mzList"
                      :key="item.code"
                      :label="item.title"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第三行：证件类型 + 证件号码 -->
            <el-row>
              <el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
                <el-form-item label="证件类型：" prop="ids_type">
                  <el-select
                    v-model="form.ids_type"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in zjlxList"
                      :key="item.code"
                      :label="item.title"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="23"
                :md="23"
                :lg="{ span: 10, offset: 1 }"
                :xl="{ span: 10, offset: 2 }"
              >
                <el-form-item
                  label="证件号码："
                  prop="idcard"
                  style="width: 100%"
                >
                  <el-input v-model="form.idcard" size="large" />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第四行：出生日期 + 到店时间 -->
            <el-row>
              <el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
                <el-form-item label="出生日期：" prop="birthday">
                  <el-date-picker
                    v-model="form.birthday"
                    type="date"
                    placeholder="选择日期"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="23"
                :md="23"
                :lg="{ span: 10, offset: 1 }"
                :xl="{ span: 10, offset: 2 }"
              >
                <el-form-item label="到店时间：" prop="daodian_time">
                  <el-date-picker
                    v-model="form.daodian_time"
                    type="datetime"
                    value-format="timestamp"
                    format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择到店时间"
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第五行：常驻地址（省市区级联 + 详细地址） -->
            <el-row>
              <el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
                <el-form-item label="常驻地址：" prop="huji1" ref="huji1">
                  <el-cascader
                    v-model="form.huji1"
                    :options="dizhiList"
                    @change="hujiChange"
                    :props="cascaderProps"
                    style="width: 100%"
                    placeholder="请选择"
                    clearable
                    filterable
                    :disabled="guojiDisabled || hjdiDisabled"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="23"
                :md="23"
                :lg="{ span: 11 }"
                :xl="{ span: 12 }"
                class="special"
              >
                <el-form-item prop="huji2">
                  <el-input v-model="form.huji2" size="large" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <!-- 右侧照片上传区域 -->
          <el-col class="pesky_right">
            <el-col class="photo_box" :span="24">
              <el-row class="photo_row">
                <el-form-item
                  label="照片上传："
                  prop="image_url"
                  label-width="110px"
                >
                  <el-upload
                    class="avatar-uploader"
                    action="#"
                    :http-request="handleHttpRequest"
                    :show-file-list="false"
                  >
                    <img
                      v-if="form.image_url"
                      :src="form.image_url"
                      class="avatar"
                      alt=""
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon" />
                  </el-upload>
                </el-form-item>
              </el-row>
            </el-col>
          </el-col>
        </el-row>
        <!-- 底部按钮区域 -->
        <div class="footer-buttons">
          <el-button type="info" @click="$router.back()">返回</el-button>
          <el-button class="change" type="primary" @click="handleSubmit"
            >确定</el-button
          >
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>
/**
 * @file 重点关注人员新增页面
 * @description 用于新增重点关注人员信息，支持身份证读卡器自动填充数据
 */
import * as user from '@/api/user'
import { lists } from '@/utils/dictionary.js'
import dizhi from '@/utils/dizhi'
import { regular } from '@/utils/validate'
/**
 * 字典代码常量定义
 * @constant {Object}
 * @property {string} XUELI - 学历代码
 * @property {string} XINGBIE - 性别代码
 * @property {string} MINZU - 民族代码
 * @property {string} ZHENGJIANLX - 证件类型代码
 */
const DICT_CODES = {
  XUELI: 'XX',
  XINGBIE: 'XB',
  MINZU: 'NATION',
  ZHENGJIANLX: '0203'
}
/**
 * 获取表单初始数据
 * @returns {Object} 表单初始值对象
 */
const getInitialForm = () => ({
  image_url: '', // 照片URL
  huji: '', // 户籍完整地址
  huji1: [], // 户籍省市区级联值
  huji2: '', // 户籍详细地址
  sex: '', // 性别
  name: '', // 姓名
  mobile: '', // 手机号
  nation: '', // 民族
  ids_type: '', // 证件类型
  idcard: '', // 证件号码
  birthday: '', // 出生日期
  daodian_time: '' // 到店时间
})
/**
 * 获取表单验证规则
 * @returns {Object} 验证规则对象
 */
const getValidationRules = () => ({
  name: [{ required: true, message: '请输入人员姓名', trigger: 'change' }],
  mobile: [
    { required: true, message: '请输入联系电话', trigger: 'change' },
    {
      pattern: regular.phone,
      message: '请输入正确的手机号码',
      trigger: 'change'
    }
  ],
  sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
  ids_type: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
  idcard: [
    { required: true, message: '请输入证件号码', trigger: 'change' },
    {
      validator: regular.IDCard,
      message: '请输入正确的证件号码',
      trigger: 'change'
    }
  ],
  huji1: [{ required: true, message: '请选择省市区', trigger: 'change' }],
  huji2: [{ required: true, message: '请完善常驻地址', trigger: 'change' }],
  daodian_time: [
    { required: true, message: '请选择到店日期', trigger: 'change' }
  ]
})
export default {
  name: 'AddPointperson',
  data() {
    return {
      // 省份首字符缓存，用于处理直辖市地址
      firstPlace: '',
      // 面包屑导航数据
      breadcrumbList: [
        { name: '重点关注人员', path: 'pointperson' },
        { name: '新增', path: 'pointperson/add_pointperson' }
      ],
      // 表单数据对象
      form: getInitialForm(),
      // 上传请求头
      headers: { 'Content-Type': 'multipart/form-data' },
      // 性别下拉列表
      xbList: [],
      // 民族下拉列表
      mzList: [],
      // 证件类型下拉列表
      zjlxList: [],
      // 地址级联数据
      dizhiList: [],
      // 表单验证规则
      rules: getValidationRules(),
      // 国籍是否禁用（非中国国籍时禁用民族和地址选择）
      guojiDisabled: false,
      // 户籍地是否禁用
      hjdiDisabled: false,
      // 确认按钮状态标记
      isOkAtate: 0,
      // 缓存标记（0-返回，1-确认）
      cache: 0,
      // 级联选择器配置
      cascaderProps: { value: 'name', label: 'name' }
    }
  },
  created() {
    // 初始化时获取字典数据
    this.getSelectList()
  },
  async mounted() {
    // 页面挂载后初始化
    this.info()
  },
  watch: {
    /**
     * 监听民族变化
     * @description 当民族变化时，恢复相关验证规则
     */
    'form.nation'() {
      this.rules.cyry_mzbm = [
        { required: true, message: '请选择民族', trigger: 'change' }
      ]
      this.rules.huji1 = [
        { required: true, message: '请选择省市区', trigger: 'change' }
      ]
      this.guojiDisabled = false
    },
    /**
     * 监听户籍地禁用状态变化
     * @param {boolean} val - 是否禁用
     * @description 禁用时清除地址验证规则，启用时恢复
     */
    hjdiDisabled(val) {
      this.rules.huji1 = val
        ? []
        : [{ required: true, message: '请选择省市区', trigger: 'change' }]
    },
    /**
     * 监听确认状态变化
     * @param {number} val - 确认状态
     * @description 状态为1时清除验证并提交表单
     */
    isOkAtate(val) {
      if (val === 1) {
        this.$refs.huji1.clearValidate()
        setTimeout(() => this.handleSubmit(), 20)
      }
    },
    /**
     * 监听缓存标记变化
     * @param {number} val - 缓存标记值
     * @description 确认时清除页面缓存
     */
    cache(val) {
      if (val === 1) {
        this.$store.commit('setKeep', '')
      }
    },
    /**
     * 监听身份证读卡器状态
     * @param {boolean} newVal - 是否有新读卡数据
     * @description 当有读卡数据时自动填充表单
     */
    '$store.state.user.isAddE'(newVal) {
      if (newVal) {
        this.setData()
        this.hjdiDisabled = true
      }
    }
  },
  methods: {
    /**
     * 设置身份证读卡器数据到表单
     * @description 从 sessionStorage 读取读卡数据并填充表单
     * @async
     */
    async setData() {
      const empData = JSON.parse(sessionStorage.getItem('addEmpData') || '[]')
      if (empData.length === 0) return
      // 判断读卡设备类型：CVR-100UC 或其他设备
      const isCvrDevice = empData[0] === 'CVR-100UC'
      const extractor = this.createDataExtractor(empData, isCvrDevice)
      // 获取并处理地址数据
      const addressData = extractor.getAddressData()
      this.getAddress(this.dizhiList, addressData.prefix, '')
      // 通过标题查找对应的字典代码
      const zjlxCode = this.findCodeByTitle(
        this.zjlxList,
        extractor.getIdType()
      )
      const mzCode = this.findCodeByTitle(
        this.mzList,
        extractor.getNation(),
        true
      )
      const sexCode = this.findCodeByTitle(this.xbList, extractor.getSex())
      const birthday = extractor.getBirthday()
      const addressDetail = extractor.getAddressDetail()
      const imageBase64 = extractor.getImageBase64()
      // 批量设置表单字段
      await this.setFormFields({
        ids_type: zjlxCode,
        idcard: extractor.getIdCard(),
        name: extractor.getName(),
        sex: sexCode,
        birthday,
        huji2: addressDetail,
        image_url: `data:image/jpeg;base64,${imageBase64}`,
        huji1: [],
        nation: mzCode
      })
      // 清除读卡状态和数据缓存
      this.$store.dispatch('user/changeAddEState', false)
      sessionStorage.removeItem('addEmpData')
    },
    /**
     * 创建数据提取器
     * @param {Array} empData - 读卡器原始数据数组
     * @param {boolean} isCvrDevice - 是否为 CVR-100UC 设备
     * @returns {Object} 数据提取器对象，包含各种 getter 方法
     * @description 根据设备类型返回对应索引的数据提取器，统一处理不同读卡器的数据格式差异
     */
    createDataExtractor(empData, isCvrDevice) {
      // 定义不同设备的字段索引映射
      const INDEX_MAP = {
        CVR: {
          name: 3, // 姓名
          sex: 4, // 性别
          nation: 5, // 民族
          birthday: 6, // 出生日期
          address: 7, // 地址
          idcard: 8, // 身份证号
          image: 19, // 照片Base64
          idType: 2 // 证件类型
        },
        OTHER: {
          name: 1,
          sex: 2,
          nation: 3,
          birthday: 4,
          address: 5,
          idcard: 6,
          image: 17,
          idType: 0
        }
      }
      const idx = isCvrDevice ? INDEX_MAP.CVR : INDEX_MAP.OTHER
      return {
        /** @returns {string} 姓名 */
        getName: () => empData[idx.name],
        /** @returns {string} 性别 */
        getSex: () => empData[idx.sex],
        /** @returns {string} 民族 */
        getNation: () => empData[idx.nation],
        /**
         * @returns {string} 格式化后的出生日期 yyyy-MM-dd
         */
        getBirthday: () => {
          const date = empData[idx.birthday]
          return isCvrDevice
            ? `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`
            : date.split(' ')[0]
        },
        /**
         * @returns {Object} 地址数据对象
         * @property {string} prefix - 地址前缀（前3位）
         * @property {string} full - 完整地址字符串（省 市 区）
         */
        getAddressData: () => {
          const addr = empData[idx.address]
          const hasProvince = addr.slice(0, 3).includes('省')
          return {
            prefix: addr.slice(0, 3),
            full: hasProvince
              ? `${addr.slice(0, 3)} ${addr.slice(3, 6)} ${addr.slice(6, 9)}`
              : `${this.firstPlace} ${addr.slice(0, 3)} ${addr.slice(3, 6)}`
          }
        },
        /** @returns {string} 详细地址 */
        getAddressDetail: () => empData[idx.address],
        /** @returns {string} 身份证号 */
        getIdCard: () => empData[idx.idcard],
        /** @returns {string} 照片Base64数据 */
        getImageBase64: () => empData[idx.image],
        /** @returns {string} 证件类型 */
        getIdType: () => empData[idx.idType]
      }
    },
    /**
     * 根据标题查找字典代码
     * @param {Array} list - 字典列表
     * @param {string} title - 要查找的标题
     * @param {boolean} [isFuzzy=false] - 是否使用模糊匹配
     * @returns {string|undefined} 对应的 code 值
     */
    findCodeByTitle(list, title, isFuzzy = false) {
      const item = isFuzzy
        ? list.find(i => i.title.includes(title))
        : list.find(i => i.title === title)
      return item?.code
    },
    /**
     * 批量设置表单字段
     * @param {Object} fields - 字段键值对对象
     * @async
     */
    async setFormFields(fields) {
      for (const [key, value] of Object.entries(fields)) {
        await this.$set(this.form, key, value)
      }
    },
    /**
     * 递归查找地址名称
     * @param {Array} data - 地址树形数据
     * @param {string} sameName - 要查找的名称
     * @param {string} pName - 父级名称
     * @description 用于获取省份首字符，处理直辖市地址格式
     */
    getAddress(data, sameName, pName) {
      data.forEach(item => {
        if (item.name === sameName) {
          this.firstPlace = pName || item.name
        } else if (item.children) {
          this.getAddress(item.children, sameName, item.name)
        }
      })
    },
    /**
     * 页面初始化
     * @description 设置页面标题，初始化表单默认值
     * @async
     */
    async info() {
      this.$set(this.form, 'nation', '')
      this.$set(this.form, 'sex', '')
      this.breadcrumbList[1].name = '新增'
    },
    /**
     * 处理后端返回数据回填
     * @param {Object} res - 后端返回的数据对象
     * @description 将接口数据转换为表单可用格式
     */
    dealData(res) {
      this.processAddressField(res.cyry_hjdz, 'huji1', 'huji2')
      this.form.daodian_time = res.cyry_rzrq ? res.cyry_rzrq * 1000 : ''
      if (res.cyry_csrq) {
        this.form.birthday = this.formatTimestamp(res.cyry_csrq)
      }
    },
    /**
     * 处理地址字段
     * @param {string} addressStr - 地址字符串，格式：省-市-区-详细地址
     * @param {string} cascadeField - 级联字段名
     * @param {string} detailField - 详细字段名
     * @description 将地址字符串拆分为级联值和详细地址
     */
    processAddressField(addressStr, cascadeField, detailField) {
      const parts = addressStr ? addressStr.split('-') : []
      const cascadeParts = parts.slice(0, 3).filter(Boolean)
      const detailPart =
        parts.length > 3
          ? parts.slice(3).join('-')
          : parts[parts.length - 1] || ''
      this.$set(this.form, cascadeField, cascadeParts)
      this.$set(this.form, detailField, detailPart)
    },
    /**
     * 格式化时间戳为日期字符串
     * @param {number} ts - Unix 时间戳（秒）
     * @returns {string} 格式化后的日期 yyyy-MM-dd
     */
    formatTimestamp(ts) {
      const date = new Date(ts * 1000)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        '0'
      )}-${String(date.getDate()).padStart(2, '0')}`
    },
    /**
     * 获取字典下拉列表数据
     * @description 从字典工具函数加载性别、民族、证件类型等数据
     */
    getSelectList() {
      this.xbList = lists[DICT_CODES.XINGBIE]
      this.mzList = lists[DICT_CODES.MINZU]
      this.zjlxList = lists[DICT_CODES.ZHENGJIANLX]
      this.dizhiList = dizhi
    },
    /**
     * 处理图片上传
     * @param {Object} e - 上传事件对象
     * @param {File} e.file - 上传的文件对象
     * @description 验证文件类型和大小后上传到服务器
     * @async
     */
    async handleHttpRequest(e) {
      const validTypes = ['image/jpeg', 'image/png', 'image/gif']
      const isValidType = validTypes.includes(e.file.type)
      const isValidSize = e.file.size / 1024 / 1024 < 1
      if (!isValidType) {
        this.$message.warning('证件照片只能是 JPG/PNG/GIF 格式!')
        return
      }
      if (!isValidSize) {
        this.$message.warning('证件照片大小不能超过 1MB!')
        return
      }
      const formData = new FormData()
      formData.append('image', e.file)
      const res = await user.uploadImg(formData)
      this.$set(this.form, 'image_url', res.showimg)
    },
    /**
     * 户籍地址级联选择变化处理
     * @param {Array} val - 选中的级联值数组
     * @description 将选中的省市区拼接为字符串保存
     */
    hujiChange(val) {
      if (val) {
        this.form.huji = val.join('-')
      }
    },
    /**
     * 表单提交处理
     * @description 验证表单数据并提交到后端
     * @async
     */
    handleSubmit() {
      this.cache = 1
      this.$refs.form.validate(async valid => {
        if (!valid) return false
        const hujiData = this.form.huji1.join('-')
        await user.addPointperson({
          name: this.form.name,
          mobile: this.form.mobile,
          sex: this.form.sex,
          nation: this.form.nation,
          ids_type: this.form.ids_type,
          idcard: this.form.idcard,
          birthday: this.form.birthday,
          address: `${hujiData}-${this.form.huji2}`,
          image_url: this.form.image_url,
          daodian_time: this.form.daodian_time
            ? this.form.daodian_time / 1000
            : ''
        })
        this.$message.success('新增成功!')
        this.$router.push('/pointperson')
      })
    }
  }
}
</script>
<style lang="less" scoped>
/* 主容器样式 */
.main {
  margin: 20px;
  padding: 20px 20px;
  /* 页面标题样式 */
  .title_a {
    margin-left: 5px;
    font-size: 18px;
    font-family: "Source Han Sans SC", "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
    font-weight: bold;
    color: #6345d5;
    line-height: 36px;
  }
  /* 底部按钮区域 */
  .footer-buttons {
    text-align: center;
    margin-top: 51px;
  }
  /* 表单区域样式 - 深度选择器覆盖 Element UI 默认样式 */
  /deep/ .form {
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100%;
      height: 100%;
      text-align: center;
    }
    .avatar {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  /* 左侧表单区域 */
  .pesky_left {
    margin-top: 20px;
    .special {
      /deep/ .el-form-item__content {
        margin-left: 50px !important;
      }
    }
  }
  /* 输入框统一高度 */
  /deep/ .el-input--large,
  /deep/ .el-input,
  /deep/ .el-input__inner {
    height: 50px;
  }
  /* 右侧照片区域 */
  .pesky_right {
    flex: 1;
    padding-top: 22px;
    /deep/ .el-row {
      width: 100%;
    }
  }
  /* 输入框后缀居中 */
  /deep/ .el-input__suffix {
    text-align: center;
  }
  /* 照片上传框样式 */
  .photo_box {
    position: relative;
    height: 100%;
    width: 90%;
    .photo_row {
      /deep/ .el-form-item__label {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
      }
      /deep/ .avatar-uploader,
      /deep/ .el-upload,
      /deep/ .el-upload--text,
      /deep/ .el-icon-plus,
      /deep/ .avatar-uploader-icon {
        width: 100%;
        height: 100%;
      }
      /deep/ .avatar-uploader-icon {
        line-height: 120px;
      }
      /deep/ .el-form-item__content {
        width: 120px;
        height: 120px;
      }
    }
  }
}
</style>
